import { AWSUploader } from './uploader-aws';
import { UploaderCos } from './uploader-cos';
import { isBuildIn, isMinioProvider } from './util';

// export const fileUploader = isBuildIn() ? new AWSUploader() : new UploaderAliyun();
export const fileUploader =
  isBuildIn() || isMinioProvider() ? new AWSUploader() : new UploaderCos();
